import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Form, Input, Select, Switch, Button, Space, notification, InputNumber } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, CheckOutlined, CloseOutlined, InfoCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';

import languageManager from '../../../services/languageManager';
import * as storeActions from './store/actions/prices';

import Loader from '../../common/PageElements/Loader';
import PageHeader from '../../common/PageElements/PageHeader'

import SelectCategorySingle from '../../catalogue/categories/widget/SelectCategorySingle'

class PricesEdit extends Component {

   state = {
      saveAndClose: false,
      loader: true,
      formValues: {},
      componentLanguage: this.props.authState.defaultLanguage,
      categoriesTree: [],
      brandsList: [],
      tagsList: [],
      marketplacesList: [],
      priceRulesSetsList: [],
      showCategorySelect: false,
      showBrandSelect: false,
      showTagSelect: false,
   };

   setForm = (response, lang = this.state.componentLanguage) => {
      const values = {
         marketplace_id: response.marketplace_id,
         price_rules_set_id: response.price_rules_set_id,
         tax_rate_id: response.tax_rate_id,
         on_category: response.on_category,
         category_id: response.category_id,
         on_brand: response.on_brand,
         brand_id: response.brand_id,
         on_tag: response.on_tag,
         tag_id: response.tag_id,
         active: response.active,
         id: response.id,
         language: lang
      }
      return values;
   }

   componentDidMount() {
      storeActions.getComplements()
         .then(response => {
            console.log(response);
            try {
               this.setState({
                  complementsResponse: response,
                  categoriesTree: response.categoriesTree,
                  brandsList: response.brandsList,
                  tagsList: response.tagsList,
                  marketplacesList: response.marketplacesList,
                  priceRulesSetsList: response.priceRulesSetsList
               });
            } catch (e) {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            if (this.props.commonState.debug) console.log(e);
         });

      if (this.props.match.params.id) {
         const itemId = this.props.match.params.id;
         // asyncronous calls
         storeActions.getItem(itemId)
            .then(response => {
               console.log(response);
               try {
                  const updatedValues = this.setForm(response.data);
                  const setShowCategorySelect = updatedValues.on_category
                  const setShowBrandSelect = updatedValues.on_brand
                  const setShowTagSelect = updatedValues.on_tag
                  this.setState({
                     action: 'edit',
                     getItemResponse: response.data,
                     formValues: updatedValues,
                     showCategorySelect: setShowCategorySelect,
                     showBrandSelect: setShowBrandSelect,
                     showTagSelect: setShowTagSelect,
                     loader: false
                  });
               } catch (e) {
                  notification.open({
                     message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                     description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                     icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
                  })
                  if (this.props.commonState.debug) console.log(e);
               }

            }).catch((e) => {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.props.commonState.debug) console.log(e);
            });
      }
      else {
         const formValues = {
            language: this.state.componentLanguage
         }
         this.setState({
            formValues: formValues,
            action: 'insert',
            loader: false
         });
      }
   }

   handleSaveAndClose = () => {
      this.setState({ saveAndClose: true });
   }

   onFinish = values => {
      console.log(values);
      this.setState({ loader: true });
      storeActions.createOrUpdate(values)
         .then(response => {
            console.log(response);
            try {
               this.setState({ loader: false });
               if (this.state.saveAndClose) {
                  this.props.history.push('/prices/list');
               }

               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.confirm.title'),
                  description: languageManager.getMessage(this.props.commonState, this.state.action === 'edit' ? 'notification.confirm.updateOk' : 'notification.confirm.insertOk'),
                  icon: <CheckCircleOutlined className="color-green-I" />,
               })
            } catch (e) {
               this.setState({ loader: false });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <CloseCircleOutlined className="color-red-I" />,
               })
            }

         }).catch((e) => {
            this.setState({ loader: false });
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <CloseCircleOutlined className="color-red-I" />,
            })
         });
   };

   onFinishFailed = errorInfo => {
      notification.open({
         message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
         description: languageManager.getMessage(this.props.commonState, 'notification.error.formInvalid'),
         icon: <CloseCircleOutlined className="color-red-I" />,
      })
   };

   toggleCategorySelect = checked => {
      this.setState({ showCategorySelect: checked });
   }

   toggleBrandSelect = checked => {
      console.log("toggle");
      this.setState({ showBrandSelect: checked });
   }

   toggleTagSelect = checked => {
      this.setState({ showTagSelect: checked });
   }

   // formatNumber = event => {
   //    console.log(event.target.value)
   //    // value.replace(',', '.');
   // }

   render() {
      if (!this.props.authState.userData.languages) return '';
      // console.log(this.props.authState.userData.languages);
      const layout = {
         labelCol: { span: 8 },
         wrapperCol: { span: 14 },
      };
      const tailLayout = {
         wrapperCol: { offset: 8, span: 16 },
      };
      const { TextArea } = Input;
      const { Option } = Select;


      let form = (
         <Form
            {...layout}
            id="formMarketplacePrices"
            name="basic"
            initialValues={this.state.formValues}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
         >
            <Form.Item
               label="Marketplace"
               name="marketplace_id"
               rules={[{ required: true }]}
            >

               <Select
                  showSearch
                  // style={{ width: 200 }}
                  placeholder="Seleziona il marketplace"
                  optionFilterProp="children"
               //  filterOption={(input, option) =>
               //    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
               //  }
               >
                  {
                     this.state.marketplacesList.map((marketplace) => {
                        return <Option key={marketplace.id} value={marketplace.id}>{marketplace.name + ' (' + marketplace.country.code + ')'}</Option>
                     })
                  }
               </Select>

            </Form.Item>
            <Form.Item
               label="Set di regole"
               name="price_rules_set_id"
               rules={[{ required: true }]}
            >

               <Select
                  showSearch
                  // style={{ width: 200 }}
                  placeholder="Seleziona il set di regole"
                  optionFilterProp="children"
               //  filterOption={(input, option) =>
               //    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
               //  }
               >
                  {
                     this.state.priceRulesSetsList.map((set) => {
                        return <Option key={set.id} value={set.id}>{set.name}</Option>
                     })
                  }
               </Select>

            </Form.Item>
            <Form.Item
               label="Variazione su categoria"
               name="on_category"
               valuePropName="checked"
            >
               <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  // defaultChecked={this.state.formValues.on_category}
                  onChange={this.toggleCategorySelect}
               />
            </Form.Item>

            {this.state.showCategorySelect ? (
               <Form.Item
                  label="Seleziona la categoria"
                  name="category_id"
                  // rules={[{ required: this.state.showCategorySelect }]}
               >
                  <SelectCategorySingle
                     categories_tree={this.state.categoriesTree}
                     placeholder="Seleziona la categoria"
                  />
               </Form.Item>
            ) : ''}

            <Form.Item
               label="Variazione su brand"
               name="on_brand"
               valuePropName="checked"
            >
               <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  // defaultChecked={this.state.formValues.on_brand}
                  onChange={this.toggleBrandSelect}
               />
            </Form.Item>

            {this.state.showBrandSelect ? (
               <Form.Item
                  label="Seleziona il brand"
                  name="brand_id"
                  rules={[{ required: this.state.showBrandSelect }]}
               >
                  <Select
                     showSearch
                     placeholder="Seleziona il brand"
                     optionFilterProp="children"
                  >
                     {
                        this.state.brandsList.map((brand) => {
                           return <Option key={brand.id} value={brand.id}>{brand.name}</Option>
                        })
                     }
                  </Select>
               </Form.Item>
            ) : ''}

            <Form.Item
               label="Variazione su tag"
               name="on_tag"
               valuePropName="checked"
            >
               <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  // defaultChecked={this.state.formValues.on_brand}
                  onChange={this.toggleTagSelect}
               />
            </Form.Item>

            {this.state.showTagSelect ? (
               <Form.Item
                  label="Seleziona il tag"
                  name="tag_id"
                  rules={[{ required: this.state.showTagSelect }]}
               >
                  <Select
                     showSearch
                     placeholder="Seleziona il tag"
                     optionFilterProp="children"
                  >
                     {
                        this.state.tagsList.map((tag) => {
                           return <Option key={tag.id} value={tag.id}>{tag.t_name}</Option>
                        })
                     }
                  </Select>
               </Form.Item>
            ) : ''}

            <Form.Item
               label="Attivo"
               name="active"
               valuePropName="checked"
            >
               <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  defaultChecked={this.state.formValues.active}
               />
            </Form.Item>

            <Form.Item label="id" name="id" noStyle><Input type="hidden" /></Form.Item>
            <Form.Item label="language" name="language" noStyle><Input type="hidden" /></Form.Item>

         </Form>
      );


      const pageContent = (
         <div className="card">
            <div className="card-header"></div>
            <div className="card-body">
               {this.state.loader ? <Loader /> : form}
            </div>
            <div className="card-footer">
               <div className="align-items-center row">
                  <div className="col-sm-6">
                     <Space>
                        <Button
                           size='large'
                           onClick={() => { this.props.history.goBack() }}
                        >
                           <i className="mdi mdi-arrow-left-drop-circle-outline mr-1"></i>
                           {languageManager.getMessage(this.props.commonState, 'common.back')}
                        </Button>
                     </Space>
                  </div>

                  <div className="col-sm-6">
                     <div className="float-right d-none d-md-block">

                        <Space>
                           <Button form="formMarketplacePrices" htmlType="button" onClick={this.onReset}>Annulla</Button>
                           <Button form="formMarketplacePrices" type="primary" htmlType="submit">Salva</Button>
                           <Button form="formMarketplacePrices" type="primary" htmlType="submit" onClick={this.handleSaveAndClose}>Salva e chiudi</Button>
                        </Space>

                     </div>
                  </div>
               </div>
            </div>
         </div>
      );

      return (
         <div className="container-fluid">
            <PageHeader
               title={languageManager.getMessage(this.props.commonState, 'component.price_rules.title')}
               buttons={[]}
            />
            <div className="row">
               <div className="col">
                  {pageContent}
               </div>
            </div>
         </div>

      );
   }
}

const mapStateToProps = state => {
   return {
      authState: state.authenticationState,
      commonState: state.commonState
   };
};

// const mapDispatchToProps = dispatch => {
//     return {
//         onFetchTaxRates: () => dispatch( actions.getTaxRatesList() )

//     };
// };

export default connect(mapStateToProps)(PricesEdit);